import React from 'react';
import { TQuestions } from './questionnaire-ogd.type';
import { Col, Row, Typography } from 'antd';
import { PieChart, Pie, Cell, Legend } from 'recharts';
import Button from '/react4xp/mixins/ui/button/button';
import { localize } from '/react4xp/mixins/helpers';

const Stats = ({
    statsData,
    setStep,
    translations,
    commonTranslations,
    language,
}: {
    statsData: TQuestions[];
    setStep: (value: 'STATS' | 'MAIN' | 'QUESTIONS') => void;
    translations: Record<string, string>;
    commonTranslations: Record<string, string>;
    language: string;
}) => {
    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
    return (
        <>
            {statsData.map((item: TQuestions, index: number) => {
                const restructuredData = item.answers.map((obj) => ({
                    name: obj.answer,
                    value: Number(obj.percentage.toFixed(2)),
                }));
                return (
                    <Row
                        justify="center"
                        key={item.question + index}
                        className="service-filter-block"
                    >
                        <Col
                            offset={4}
                            md={12}
                            xs={12}
                        >
                            <Typography.Title level={4}>{item.question}</Typography.Title>
                            <span className="questionnaire-theme__anonymity-status">{localize('oprosy-total-completed', translations) + ": " + item.totalAnswersCount}</span>
                        </Col>
                        <Col>
                            <PieChart
                                width={400}
                                height={400}
                            >
                                <Pie
                                    data={restructuredData}
                                    cx="50%"
                                    cy="50%"
                                    label
                                    outerRadius={130}
                                    fill="#8884d8"
                                    nameKey="name"
                                    dataKey="value"
                                >
                                    {restructuredData.map((entry, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={COLORS[index % COLORS.length]}
                                        />
                                    ))}
                                </Pie>
                                <Legend />
                            </PieChart>
                        </Col>
                    </Row>
                );
            })}
            <hr className="my-3" />
            <Row
                justify="start"
                gutter={[16, { md: 16, xs: 16 }]}
            >
                <Col
                    md={3}
                    xs={3}
                    lg={3}
                >
                    <Button onClick={() => setStep('MAIN')}>{localize('button.close', commonTranslations)}</Button>
                </Col>
            </Row>
        </>
    );
};

export default Stats;
